import { DollarSign, TrendingUp, TrendingDown } from "lucide-react";

export function CostEstimatePanel({ estimate, t }) {
    if (!estimate) return null;

    const { totalCredits, totalUSD, totalFiles } = estimate.estimate;
    const { low, lowUSD, mid, midUSD, high, highUSD } = estimate.ranges;

    return (
        <div className="bg-gradient-to-br from-slate-50 to-blue-50/50 rounded-2xl p-6 border border-slate-200/80 sticky top-4">
            <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
                    <DollarSign className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                        {t("billing.moduleCosts.estimate") || "Cost Estimate"}
                    </h3>
                    <p className="text-xs text-gray-500">
                        {totalFiles} {t("billing.moduleCosts.files") || "files"} ·{" "}
                        {estimate.breakdown.length} {t("billing.moduleCosts.modules") || "modules"}
                    </p>
                </div>
            </div>

            <div className="text-center py-4 mb-4 bg-white rounded-xl border border-slate-100">
                <div className="text-3xl font-bold text-gray-900">{totalCredits}</div>
                <div className="text-sm text-gray-500 mt-1">
                    {t("billing.moduleCosts.credits") || "credits"} · ${totalUSD} USD
                </div>
            </div>

            <div className="space-y-2 mb-4">
                <RangeRow icon={TrendingDown} label={t("billing.moduleCosts.bestCase") || "Best case"} credits={low} usd={lowUSD} color="text-green-600" bg="bg-green-50" />
                <RangeRow icon={TrendingUp} label={t("billing.moduleCosts.typical") || "Typical"} credits={mid} usd={midUSD} color="text-blue-600" bg="bg-blue-50" active />
                <RangeRow icon={TrendingUp} label={t("billing.moduleCosts.complex") || "Complex"} credits={high} usd={highUSD} color="text-orange-600" bg="bg-orange-50" />
            </div>

            <div className="space-y-1.5 mb-4">
                {estimate.breakdown.map((mod) => (
                    <div key={mod.key} className="flex items-center justify-between text-sm">
                        <span className="text-gray-600 truncate mr-2">{mod.label}</span>
                        <span className="text-gray-900 font-medium whitespace-nowrap">
                            {mod.estimatedCredits} cr
                        </span>
                    </div>
                ))}
            </div>

            <div className="pt-4 border-t border-slate-200">
                <p className="text-xs text-amber-700 bg-amber-50 rounded-lg px-3 py-2 leading-relaxed">
                    {t("billing.moduleCosts.disclaimer") || "This is a rough estimate based on historical data from thousands of apps built on the platform. Actual costs may vary depending on the complexity of your project, number of iterations, and specific requirements."}
                </p>
            </div>
        </div>
    );
}

function RangeRow({ icon: Icon, label, credits, usd, color, bg, active }) {
    return (
        <div className={`flex items-center justify-between px-3 py-2 rounded-lg ${active ? bg : ""}`}>
            <div className="flex items-center gap-2">
                <Icon className={`w-3.5 h-3.5 ${color}`} />
                <span className={`text-sm ${active ? "font-medium text-gray-900" : "text-gray-500"}`}>{label}</span>
            </div>
            <span className={`text-sm font-medium ${color}`}>{credits} cr · ${usd}</span>
        </div>
    );
}
